<div class="modal fade show d-block clone-template-modal" tabindex="-1" *ngIf="isCloneModalOpen">
  <div class="modal-dialog modal-dialog-prev modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title d-flex flex-column">
          <strong>{{ modalTitle }}</strong>
        </h5>
        <button type="button" class="close" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>

      <form #cloneForm="ngForm" (ngSubmit)="submitClone(cloneForm)" style="max-height: 75vh;">
        <div class="modal-body" style="max-height: 86%;overflow-x: hidden;overflow-y: scroll;">
          <!-- Template Name -->
          <div class="mb-3">
            <label>Template Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              name="templateName"
              [(ngModel)]="templateName"
              #templateNameRef="ngModel"
              required
            />
            <div class="text-danger" *ngIf="templateNameRef.invalid && (templateNameRef.touched || formSubmitted)">
              Template name is required.
            </div>
          </div>

          <!-- Template Subject -->
          <div class="mb-3">
            <label>Template Subject <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              name="templateSubject"
              [(ngModel)]="templateSubject"
              #templateSubjectRef="ngModel"
              required
            />
            <div class="text-danger" *ngIf="templateSubjectRef.invalid && (templateSubjectRef.touched || formSubmitted)">
              Template subject is required.
            </div>
          </div>

          <!-- Domain -->
          <div class="mb-3">
            <mat-form-field appearance="outline" class="formstyle matSelectDropdown">
              <mat-label>Select Domain </mat-label>
              <mat-select
                name="domainID"
                [(value)]="domainID"
                (selectionChange)="onDomainChange($event)"
                required
                #domainRef="ngModel"
                [ngModel]="domainID"
              >
                <mat-option *ngFor="let d of domainData" [value]="d.id">
                  {{ d.domain_name }}
                </mat-option>
                <mat-option *ngIf="!domainData || domainData.length === 0" disabled>
                  No data available
                </mat-option>
              </mat-select>
              <div class="text-danger" *ngIf="!domainID && formSubmitted">
                Domain is required.
              </div>
            </mat-form-field>
          </div>

          <!-- Journey -->
          <div class="mb-3">
            <mat-form-field appearance="outline" class="formstyle matSelectDropdown">
              <mat-label>Select Journey </mat-label>
              <mat-select
                name="journeyID"
                [(value)]="journeyID"
                (selectionChange)="onJourneyChange($event)"
                required
                #journeyRef="ngModel"
                [ngModel]="journeyID"
              >
                <mat-option *ngFor="let j of jorneyType" [value]="j.journey_id">
                  {{ j.journey_name }}
                </mat-option>
                <mat-option *ngIf="!jorneyType || jorneyType.length === 0" disabled>
                  No data available
                </mat-option>
              </mat-select>
              <div class="text-danger" *ngIf="!journeyID && formSubmitted">
                Journey is required.
              </div>
            </mat-form-field>
          </div>


          <!-- Theme -->
          <div class="mb-3">
            <mat-form-field appearance="outline" class="formstyle matSelectDropdown">
              <mat-label>Select Theme </mat-label>
              <mat-select
                multiple
                name="themesID"
                [(value)]="themesID"
                (selectionChange)="onThemeChange($event)"
                required
                #themeRef="ngModel"
                [ngModel]="themesID"
              >
                <mat-option *ngFor="let t of themeList" [value]="t.theme_id">
                  {{ t.theme_name }}
                </mat-option>
                <mat-option *ngIf="!themeList || themeList.length === 0" disabled>
                  No data available
                </mat-option>
              </mat-select>
              <div class="text-danger" *ngIf="(!themesID || themesID.length === 0) && formSubmitted">
                At least one theme is required.
              </div>
            </mat-form-field>
          </div>

        </div>

        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!templateName?.trim() || !templateSubject?.trim() || !domainID || !journeyID || !themesID?.length"
          >
            Clone Template
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show clone-template-modal-backdrop" *ngIf="isCloneModalOpen"></div>